import React from 'react'
import { AppBasicTable, AppReportSearchesModal, AppResultsSkeleton } from '@components'
import { useManageHomeStatus, useReportsHomeInfo } from 'Pages/Main/Home/@hooks'
import { dateColumn, reportNameColumn } from './columns'
import ReportListTableHomeCustomToolbar from './Toolbar'


export default function ReportsHomeTable() {
	const { data, isLoading } = useReportsHomeInfo()
	useManageHomeStatus()


	if (isLoading) return <AppResultsSkeleton rows={9} columns={2}/>

	return <>
		<AppBasicTable
			title="Last Report Executions"
			toolbarProps={{ actions: false }}
			titleProps={{ actions: false }}
			sx={{ height: 313 }}
			data={data.filter(report => report.statusLastExecution && report.enabled)}
			setHeaderCellProps={(_, idx) => ({
				sx: {
						textAlign: !idx && 'left !important',
				},
			})}
			headers={[[
				{ label: 'Name' },
				{ label: 'Status' },
			]]}
			columns={[
				reportNameColumn(),
				dateColumn(),
			]}
			Components={{
				Title: ({ title }) => <ReportListTableHomeCustomToolbar title={title}/>,
			}}
		/>
		<AppReportSearchesModal data={data}/>
	</>
}